import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { scrollAppToTop, scrollToHashWhenReady } from '../utils/scrollToHash';

export const ScrollOnNavigate = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      return scrollToHashWhenReady(hash);
    }
    scrollAppToTop('instant');
  }, [pathname, hash]);

  return null;
};
